import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["editMode", "href", "anchorText", "target", "emptyText"];
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import React from "react";
import TextField from "../TextField/TextField";

// type UrlFieldProps = {
//     editMode?: boolean;
//     href: string;
//     anchorText?: string;
//     target?: string;
//     emptyText?: string | null;
//     label?: string;
//     id?: string;
// };
import { jsx as _jsx } from "react/jsx-runtime";
export default function UrlField(_ref) {
  var _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? true : _ref$editMode,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? "" : _ref$href,
    _ref$anchorText = _ref.anchorText,
    anchorText = _ref$anchorText === void 0 ? "" : _ref$anchorText,
    target = _ref.target,
    _ref$emptyText = _ref.emptyText,
    emptyText = _ref$emptyText === void 0 ? null : _ref$emptyText,
    props = _objectWithoutProperties(_ref, _excluded);
  if (editMode) {
    return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, props), {}, {
      editMode: true,
      value: href
    }));
  }
  if (!href) {
    return emptyText;
  }
  if (!_startsWithInstanceProperty(href).call(href, "http://") && !_startsWithInstanceProperty(href).call(href, "https://")) {
    href = "https://".concat(href);
  }
  return /*#__PURE__*/_jsx("a", {
    href: href,
    target: target,
    children: anchorText
  });
}